import { Field, ObjectType } from 'type-graphql'

@ObjectType()
export class CheckVisionModelRateResult {
  /** The model identifier the guard checked — `args.model` when passed, else `openAiConfig.visionModel`. */
  @Field(() => String)
  configuredModel: string

  /** Whether an active `ModelRate` row exists for `configuredModel`. */
  @Field(() => Boolean)
  hasActiveRate: boolean
}
